import React from "react";
import { canShowOnvifScan } from "../../../utils/onvifScanAccess";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { AddCameraButton } from "./AddCameraButton";
import { CameraIcon } from "../../../common/CameraIcon";
import { NavigateFunction } from "react-router-dom";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const NoCameras = ({
  navigate,
  setNoAutoAddCamerasDialogOpen,
  siteInfo,
  permissions,
}: {
  navigate: NavigateFunction;
  setNoAutoAddCamerasDialogOpen: Dispatcher<boolean>;
  siteInfo?: any;
  permissions?: any;
}) => {
  // ONVIF scan is how you add the FIRST cameras to an empty site, so it must be
  // available here too — not only once cameras already exist (CamerasTable).
  const showOnvifScan = canShowOnvifScan(
    permissions,
    siteInfo?.integration_type_name
  );

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer>
        <Typography
          sx={{
            fontFamily: "Mulish",
            fontWeight: "Bold",
            textIndent: "33px",
            paddingTop: "10px",
          }}
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Site Cameras
        </Typography>

        <div className="w-[88vw] h-[27.5vh] bg-white">
          <div className="flex items-center justify-center font-black">
            <CameraIcon />
          </div>
          <div className="flex items-center justify-center font-black font-mulish text-xl">
            This Site doesn&apos;t have any cameras yet.
          </div>
          <br></br>
          <div className="flex items-center justify-center gap-4 font-black font-mulish text-xl">
            <AddCameraButton
              navigate={navigate}
              setNoAutoAddCamerasDialogOpen={setNoAutoAddCamerasDialogOpen}
              siteInfo={siteInfo}
            />
            {showOnvifScan && (
              <Button
                type="button"
                variant="contained"
                sx={{
                  fontFamily: "Mulish",
                  textTransform: "none",
                  backgroundColor: "#283E6D",
                  color: "#FFFFFF",
                  "&:hover": { backgroundColor: "#1f2f54" },
                }}
                onClick={() => {
                  localStorage.setItem("addAdditionalCamera", "true");
                  navigate(`/sites/${siteInfo.id}/onvifscan`);
                }}
              >
                ONVIF Scan
              </Button>
            )}
          </div>
        </div>
      </TableContainer>
    </Paper>
  );
};
